import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * CRM Module Service Stores
 */
export const crmStores: ServiceStoreConfig[] = [
  {
    name: "customers",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.customersStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const total = entities.length;
          const active = entities.filter(
            (c: Record<string, unknown>) => c.isActive
          ).length;
          const inactive = total - active;
          const withQuickbooks = entities.filter(
            (c: Record<string, unknown>) => c.quickbooksId
          ).length;

          return [
            {
              title: "Total Customers",
              value: () => total.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => active.toString(),
              valueColor: "success.main",
            },
            {
              title: "Inactive",
              value: () => inactive.toString(),
              valueColor: "warning.main",
            },
            {
              title: "QuickBooks Synced",
              value: () => withQuickbooks.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "components",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "componentId",
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.componentsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const total = entities.length;
          const uniqueVendors = new Set(
            entities
              .map((c: Record<string, unknown>) => c.vendorId)
              .filter(Boolean)
          ).size;
          const totalCost = entities.reduce(
            (sum: number, c: Record<string, unknown>) =>
              sum + (typeof c.unitCost === "number" ? c.unitCost : 0),
            0
          ) as number;
          const avgCost = total > 0 ? (totalCost as number) / total : 0;

          return [
            {
              title: "Total Components",
              value: () => total.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Unique Vendors",
              value: () => uniqueVendors.toString(),
              valueColor: "info.main",
            },
            {
              title: "Avg Unit Cost",
              value: () => `$${(avgCost as number).toFixed(2)}`,
              valueColor: "secondary.main",
            },
            {
              title: "Total Cost",
              value: () => `$${(totalCost as number).toFixed(2)}`,
              valueColor: "success.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
  {
    name: "vendors",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "vendorId",
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.vendorsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const total = entities.length;
          const active = entities.filter(
            (v: Record<string, unknown>) => v.isActive
          ).length;
          const inactive = total - active;
          const withQuickbooks = entities.filter(
            (v: Record<string, unknown>) => v.quickbooksId
          ).length;

          return [
            {
              title: "Total Vendors",
              value: () => total.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Active",
              value: () => active.toString(),
              valueColor: "success.main",
            },
            {
              title: "Inactive",
              value: () => inactive.toString(),
              valueColor: "warning.main",
            },
            {
              title: "QuickBooks Synced",
              value: () => withQuickbooks.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
];
